import { action, makeObservable, observable } from 'mobx';
import { SUMMARY_STATUS } from './types';
interface SummaryStoreInterface {
    stoppedByServer: boolean | null;
    coolDownRecording: boolean | null;
    participants: Record<string, string> | null;
    status: SUMMARY_STATUS;
    isInitByMe: boolean;
}

class SummaryStore implements SummaryStoreInterface {
    @observable public stoppedByServer: SummaryStoreInterface['stoppedByServer'] = null;
    @observable public coolDownRecording: SummaryStoreInterface['coolDownRecording'] = null;
    @observable public participants: SummaryStoreInterface['participants'] = null;
    @observable public status: SummaryStoreInterface['status'] = SUMMARY_STATUS.INITIAL;
    @observable public isInitByMe: SummaryStoreInterface['isInitByMe'] = false;

    public constructor() {
        makeObservable(this);
    }

    @action
    public setIsInitByMe(isInitByMe: SummaryStoreInterface['isInitByMe']) {
        this.isInitByMe = isInitByMe;
    }

    @action
    public reset() {
        this.stoppedByServer = null;
        this.coolDownRecording = null;
        this.participants = null;
        this.status = SUMMARY_STATUS.INITIAL;
    }

    @action
    public setStoppedByServer(stoppedByServer: SummaryStoreInterface['stoppedByServer']) {
        this.stoppedByServer = stoppedByServer;
    }

    @action
    public setCoolDownRecording(coolDownRecording: SummaryStoreInterface['coolDownRecording']) {
        this.coolDownRecording = coolDownRecording;
    }

    @action
    public setParticipants(participants: SummaryStoreInterface['participants']) {
        this.participants = participants;
    }

    @action
    public setInitialStatus() {
        this.status = SUMMARY_STATUS.INITIAL;
    }

    @action
    public setWaitingForStartStatus() {
        this.status = SUMMARY_STATUS.WAITING_FOR_START;
    }

    @action
    public setSummarizingStatus() {
        this.status = SUMMARY_STATUS.SUMMARIZING;
    }

    @action
    public setStoppingStatus() {
        this.status = SUMMARY_STATUS.STOPPING;
    }
}

export const summaryStore = new SummaryStore();
